var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_92399521523767029599803595083876086474",
    d: "M13.659 0c3.648 0 7.078 1.42 9.658 4 2.58 2.58 4 6.01 4 9.659 0 3.648-1.42 7.078-4 9.658-2.58 2.58-6.01 4-9.658 4-3.649 0-7.079-1.42-9.659-4-2.58-2.58-4-6.01-4-9.658C0 10.01 1.42 6.58 4 4c2.58-2.58 6.01-4 9.659-4zm0 2.134c-6.355 0-11.525 5.17-11.525 11.525 0 6.354 5.17 11.524 11.525 11.524 6.354 0 11.524-5.17 11.524-11.524 0-6.355-5.17-11.525-11.524-11.525zm.479 2.419v8.498h5.591v2.125h-7.588V4.553h1.997z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_273373713458684260563451733133400481985",
    d: "M-2.763 -3.152H29.696000000000005V30.469H-2.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_331573837954344850495278960914101140685",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -367) translate(48 359) translate(16 8) translate(2.341 2.341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_262799661988735995855051893596580652110",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_92399521523767029599803595083876086474"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_92399521523767029599803595083876086474"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_262799661988735995855051893596580652110)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_273373713458684260563451733133400481985"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_331573837954344850495278960914101140685)",
    xlinkHref: "#hinava_random_uuid_273373713458684260563451733133400481985"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.a21f0b1ec7612cd03b30b8a704041a78.svg";
export { ForwardRef as ReactComponent };